import { capitalize } from "@repo/shared/utils";
import type { PhoneNumber } from "@repo/types";

export const PhoneDisplay = ({
  phone = {
    type: "",
    number: "",
  },
}: {
  phone?: PhoneNumber;
}) => {
  return (
    <div>
      {phone.number && phone.type ? capitalize(phone.type) + ": " : ""}
      {phone.number}
    </div>
  );
};
